import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { iif, Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { SurveyTableInterface } from '../../shared/interfaces/survey-table.interface';
import { BuyerSurveyResponse } from '../../shared/interfaces/survey.interface';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { SurveyStatus } from '../../shared/utils/survey-status';
import { Constants } from '../constants/manage-multi-country.constants';

@Component({
  selector: 'ps-ui-manage-multi-country',
  templateUrl: './manage-multi-country.component.html',
  styleUrls: ['./manage-multi-country.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageMultiCountryComponent implements OnInit {
  @Input() mcUniqueId?: string = '';
  @Input() surveyId!: number | undefined;

  public isSingleCountrySurvey: boolean = false;
  public constants = Constants;

  public surveys$!: Observable<SurveyTableInterface[]>;

  constructor(private _buyerApiService: BuyerApiService) {}

  public ngOnInit(): void {
    this.isSingleCountrySurvey = !this.mcUniqueId;

    let status = Object.values(SurveyStatus).filter(
      (status) => typeof status === 'number'
    );

    const surveys$ = of(status).pipe(
      map((status) => status.join(',')),
      switchMap((status) =>
        this._buyerApiService.getSurveys(status, 1, '', this.mcUniqueId)
      ),
      map((surveys) => this._filterCurrentSurvey(surveys)),
      map((surveys) => this._tranformSurveys(surveys))
    );

    this.surveys$ = iif(
      () => !!this.surveyId && !!this.mcUniqueId,
      surveys$,
      of([])
    ).pipe(startWith([]));
  }

  private _filterCurrentSurvey(surveys: BuyerSurveyResponse[]) {
    return surveys.filter((survey) => survey.ps_survey_id !== this.surveyId);
  }

  private _tranformSurveys(surveys: BuyerSurveyResponse[]) {
    return surveys.map((mSurvey) => {
      return {
        ps_survey_status: mSurvey.ps_survey_status,
        ps_survey_id: mSurvey.ps_survey_id,
        survey_title: mSurvey.survey_title,
        survey_type: 'Multicountry',
        creation_date: mSurvey.project_creation_date,
        fielded: mSurvey.fielded,
        goal: mSurvey.completes_required,
        currencySymbol: mSurvey.currency_symbol,
        avg_cpi: mSurvey.average_cpi ? mSurvey.average_cpi : 0,
        cpi_current: mSurvey.acpi ? mSurvey.acpi : 0,
        epc: mSurvey.epc,
        current_ir: mSurvey.expected_ir,
        total_starts: mSurvey.total_starts,
        last_24_starts: mSurvey.last_24_starts,
        in_progress: mSurvey.bip ? mSurvey.bip : 0,
        create_status: this.constants.CHILD_CREATION_STATUS.READY,
        invoiceType: mSurvey.company.generate_invoice,
      };
    });
  }
}
